export default __webpack_public_path__ + "static/P_SearchThumb_IN-3011-f1b1cdae497503a444e8d05261f16af5.webp";